import {textComponent} from 'quickstart/components/content/Text'
import {withClassNames} from 'quickstart/theme'
import * as R from 'rambdax'
import S from './styles.module.css'

export const Key = R.piped(textComponent('textSm'), withClassNames(S.key))
